var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { arithmeticProgressionBuckets } from "./classifiers/arithmeticProgression";
import { equalIntervalBuckets } from "./classifiers/equalIntervals";
import { geometricProgressionBuckets } from "./classifiers/geometricProgression";
import { jenksBuckets } from "./classifiers/jenks";
import { quantileBuckets } from "./classifiers/quantile";
import { standardDeviationBuckets } from "./classifiers/standardDeviation";
import { BucketTypes } from "./type";
import { calcMean, calcStandardDeviation } from "./utils";
var generateBuckets = function (name, data, numberClasses) { return __awaiter(void 0, void 0, void 0, function () {
    var buckets, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!Object.keys(BucketTypes).includes(name) &&
                    !Object.values(BucketTypes).includes(name)) {
                    throw Error("".concat(name, " not supported"));
                }
                _a = name;
                switch (_a) {
                    case BucketTypes.EQI: return [3 /*break*/, 1];
                    case BucketTypes.QNT: return [3 /*break*/, 3];
                    case BucketTypes.STD: return [3 /*break*/, 5];
                    case BucketTypes.GPG: return [3 /*break*/, 7];
                    case BucketTypes.APG: return [3 /*break*/, 9];
                    case BucketTypes.JNK: return [3 /*break*/, 11];
                }
                return [3 /*break*/, 13];
            case 1: return [4 /*yield*/, equalIntervalBuckets(data, numberClasses)];
            case 2:
                buckets = _b.sent();
                return [3 /*break*/, 14];
            case 3: return [4 /*yield*/, quantileBuckets(data, numberClasses)];
            case 4:
                buckets = _b.sent();
                return [3 /*break*/, 14];
            case 5: return [4 /*yield*/, standardDeviationBuckets(data, numberClasses)];
            case 6:
                buckets = _b.sent();
                return [3 /*break*/, 14];
            case 7: return [4 /*yield*/, geometricProgressionBuckets(data, numberClasses)];
            case 8:
                buckets = _b.sent();
                return [3 /*break*/, 14];
            case 9: return [4 /*yield*/, arithmeticProgressionBuckets(data, numberClasses)];
            case 10:
                buckets = _b.sent();
                return [3 /*break*/, 14];
            case 11: return [4 /*yield*/, jenksBuckets(data, numberClasses)];
            case 12:
                buckets = _b.sent();
                return [3 /*break*/, 14];
            case 13: throw Error("".concat(name, " not supported"));
            case 14: return [2 /*return*/, buckets];
        }
    });
}); };
export { arithmeticProgressionBuckets, equalIntervalBuckets, geometricProgressionBuckets, jenksBuckets, quantileBuckets, standardDeviationBuckets, calcStandardDeviation, calcMean, generateBuckets, BucketTypes };
